import { FikoGrup } from "../FikoGrup";
import { FikoVektor3D } from "../FikoVektor3d";
import { FikoTakimTutucu } from "./FikoTakimTutucu";


export class FikoTakim extends FikoGrup {
    override type: "FikoTakım" | any;
    tutucu: FikoTakimTutucu
    /** */
    yon: FikoVektor3D = new FikoVektor3D(0, 0, 1);
}